import type {IPromise, ITimeoutService} from 'angular';
import HistoricalPlacesMapStaticSettings from './historical-places-map-static-settings';
import bind from 'bind-decorator';

export default class HistoricalPlacesMap extends HistoricalPlacesMapStaticSettings {

    constructor(private $timeout: ITimeoutService) {
        super();
    }

    private timeouting: IPromise<void> = null;

    @bind
    public hideWindow() {
        this.window.visible = false;
    }

    public events = {
        zoom_changed: this.hideWindow
    }

    public markerEvents = {
        click: (marker, event, markerModel) => this.showWindowOnMarker(marker, markerModel),
        mouseover: (marker, event, markerModel) => this.showWindowOnMarker(marker, markerModel),
        mouseout: this.mouseOutEvent
    }

    public clusterEvents = {
        click: (cluster, clusterModels) => this.showWindowOnCluster(cluster, clusterModels),
        mouseover: (cluster, clusterModels) => this.showWindowOnCluster(cluster, clusterModels),
        mouseout: this.mouseOutEvent
    }

    public clusterOptions = {
        minimumClusterSize: 2,
        averageCenter: true,
        maxZoom: 15,
        zoomOnClick: false,
        styles: [
            {
                url: '/resources/ext/proveniences-map/marker_cluster_1.png',
                textSize: 16,
                width: 48,
                height: 48,
                anchor: [-7, 0],
                anchorIcon: [48, 24]
            },
            {
                url: '/resources/ext/proveniences-map/marker_cluster_2.png',
                textSize: 16,
                width: 48,
                height: 48,
                anchor: [-7, 0],
                anchorIcon: [48, 24]
            }
        ],
        calculator: (markers) => {
            const values: any[] = markers.values();

            const title = values
                .map((marker) => marker.model.name)
                .join(', ');

            return {
                // index: (count < 5 ? 1 : 2),
                index: 1,
                text: `${markers.length}`,
                title,
                label: title
            }
        }
    }

    @bind
    private mouseOutEvent() {
        this.timeouting = this.$timeout(this.hideWindow, 2000);
    }

    private cancelTimeout = () => {
        if (this.timeouting !== null) {
            this.$timeout.cancel(this.timeouting);
        }
    }

    private showWindowOnCluster(cluster, clusterModels) {
        this.showWindow(cluster.center_, cluster.clusterIcon_.height_, clusterModels);
    }

    private showWindowOnMarker(marker, markerModel) {
        this.showWindow(marker.position, marker.icon.size.height, [markerModel]);
    }

    private showWindow(position, iconHeight, markerModels) {
        this.cancelTimeout();

        this.$timeout(() => this.window.visible = false);

        this.$timeout(() => {
            this.window.coordinates = {
                latitude: position.lat(),
                longitude: position.lng()
            };
            this.window.markers = markerModels;
            this.window.visible = true;

            // @ts-ignore probably global namespace ?
            this.window.options.pixelOffset = new google.maps.Size(0, -iconHeight);
        });
    }

}